module.exports = __webpack_public_path__ + "img/Austin.747e7884.jpg";